module.exports = __webpack_public_path__ + "img/文字版_00.6def2af9.png";